import * as Yup from "yup";
import moment from "moment";

export const registerSchema = Yup.object().shape({
  name: Yup.string()
    .required("Name is required")
    .min(3, "Minimum name length is 3"),
  designation: Yup.string()
    .required("Name is required")
    .min(3, "Minimum name length is 3"),
  phone: Yup.string()
  .matches(/^[0-9]{10}$/, 'Invalid mobile number')
  .required('Mobile number is required'),
  email: Yup.string()
    .min(1, "Minimum email length is 1")
    .max(190, "Maximum email length is 190")
    .required("Email is required"),
  bank_id: Yup.string().required("Bank is required"),
  branch_id: Yup.string().required("Branch is required"),
  state: Yup.string().required("State is required"),
  city: Yup.string().required("City is required"),
  password: Yup.string()
    .min(8, "Minimum password length is 8")
    .max(30, "Maximum password length is 30")
    .required("Password is required"),
});

export const emailLoginSchema = Yup.object().shape({
  email: Yup.string()
    .min(1, "Minimum email length is 1")
    .max(190, "Maximum email length is 190")
    .required("Email is required"),
  password: Yup.string()
    .min(8, "Minimum password length is 8")
    .max(30, "Maximum password length is 30")
    .required("Password is required"),
});

export const mobileLoginSchema = Yup.object().shape({
  phone: Yup.string()
    .matches(/^[0-9]{10}$/, "Invalid mobile number")
    .required("Mobile number is required"),
});

export const ForgotPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .min(1, "Minimum email length is 1")
    .max(190, "Maximum email length is 190")
    .required("Email is required"),
});

export const addPropertySchema = Yup.object().shape({
  // bank_id: Yup.string().required("Bank is required"),
  // branch_id: Yup.string().required("Branch is required"),
  asset_category: Yup.string().required("Category is required"),
  property_type: Yup.string().required("Property type is required"),
  // property_name: Yup.string().required("Property name is required"),
  property_address: Yup.string().required("Address is required"),
  // province_state: Yup.string().required("State is required"),
  taluka: Yup.string().required("Bank is required"),
  // state: Yup.string().required("State is required"),
  // city: Yup.string().required("City is required"),
  // city_town: Yup.string().required("City is required"),
  area_locality: Yup.string().required("Category is required"),
  // status:Yup.string().required("Status is required"),
  land_area: Yup.string()
    .matches(/^\d+(\.\d+)?$/, "Land area must be a valid number")
    .required("Land area is required"),
  builtup_carpet_area: Yup.string()
    .matches(/^\d+(\.\d+)?$/, "carpet area must be a valid number")
    .required("carpet area is required"),
  borrower_names: Yup.string().required("Borrower Names is required"),
  possession_type: Yup.string().required("Possession Type is required"),
  description:Yup.string().required("Description is required"),
  country:Yup.string().required("Country is required"),
  reserve_price: Yup.string()
    .matches(/^\d+(\.\d+)?$/, "Reserve price must be a valid number")
    .required("Reserve price is required"),
  emd: Yup.string()
    .matches(/^\d+(\.\d+)?$/, "Emd must be a valid number")
    .required("Emd is required"),
  min_increment: Yup.string()
    .matches(/^\d+(\.\d+)?$/, "Minimum Increment must be a valid number")
    .required("Minimum Increment is required"),
    contact_number: Yup.string()
    .matches(/^\d+(\.\d+)?$/, "Contact Number must be a valid number")
    .required("Contact Number is required"),
  amount_outstanding: Yup.string()
    .matches(/^\d+(\.\d+)?$/, "Amount outstanding must be a valid number")
    .required("Amount outstanding is required"),
  dsc_required: Yup.boolean().required("This field is required"),
  contact_name:Yup.string().required("Contact Name is required"),
  auction_type: Yup.string().required("Auction Type is required"),
  auction_start_time: Yup.string().required(
    "Auction Start date & time is required"
  ),
  auction_end_time: Yup.string()
    .required("Auction End date & time is required")
    .test(
      "is-after-start",
      "Auction End date & time must be after Auction Start date & time",
      function (value) {
        const { auction_start_time } = this.parent; // Access sibling fields
        if (!value || !auction_start_time) return true; // Skip if either field is empty
        return moment(value).isAfter(moment(auction_start_time)); // Ensure end time is after start time
      }
    ),
  // auction_end_time: Yup.string().required('Auction End date & time is required'),
  time_extension: Yup.string().required("Type Extension is required"),
  application_submission_date: Yup.string().required('Application Submission date & time is required'),
  // application_submission_date: Yup.string()
  //   .required("Application Submission date & time is required")
  //   .test(
  //     "is-between-auction-times",
  //     "Application Submission date & time must be between Auction Start and Auction End times, and not the same as either",
  //     function (value) {
  //       const { auction_start_time, auction_end_time } = this.parent; // Access sibling fields
  //       if (!value || !auction_start_time || !auction_end_time) return true; // Skip if any field is empty
  //       const submissionTime = moment(value);
  //       return (
  //         submissionTime.isAfter(moment(auction_start_time)) && // After start
  //         submissionTime.isBefore(moment(auction_end_time)) && // Before end
  //         !submissionTime.isSame(moment(auction_start_time)) && // Not same as start
  //         !submissionTime.isSame(moment(auction_end_time)) // Not same as end
  //       );
  //     }
  //   ),
  property_inspection_datetime: Yup.string().required("Property Inspection date & time is required"),
  // property_inspection_datetime: Yup.string()
  // .required("Property Inspection date & time is required")
  // .test(
  //   "is-between-auction-times",
  //   "Property Inspection date & time must be between Auction Start and Auction End times, and not the same as either",
  //   function (value) {
  //     const { auction_start_time, auction_end_time } = this.parent; // Access sibling fields
  //     if (!value || !auction_start_time || !auction_end_time) return true; // Skip if any field is empty

  //     const inspectionTime = moment(value);
  //     const auctionStartTime = moment(auction_start_time);
  //     const auctionEndTime = moment(auction_end_time);

  //     return (
  //       inspectionTime.isAfter(auctionStartTime) && // After start
  //       inspectionTime.isBefore(auctionEndTime) && // Before end
  //       !inspectionTime.isSame(auctionStartTime) && // Not the same as start
  //       !inspectionTime.isSame(auctionEndTime) // Not the same as end
  //     );
  //   }
  // ),

  service_provider: Yup.string().required("Service Provider is required"),
  // property_image: Yup.mixed().required("Image is required")
  //   .test(
  //     "fileType",
  //     "Only image files (png, jpg, jpeg) are allowed",
  //     (value) =>
  //       value && ["image/png", "image/jpeg", "image/jpg"].includes(value.type)
  //   )
  //   .test(
  //     "fileSize",
  //     "File size should be less than 3MB",
  //     (value) => value && value.size <= 3 * 1024 * 1024
  //   ),
  // property_document: Yup.mixed()
  //   .required("PDF file is required")
  //   .test("fileType", "Only PDF files are allowed", (value) => {
  //     return value && value.type === "application/pdf"; // Check if the file is a PDF
  //   })
  //   .test("fileSize", "File size must be less than 5 MB", (value) => {
  //     return value && value.size <= 5 * 1024 * 1024; // Check if file size is <= 5 MB
  //   }),
  property_document: Yup.mixed()
  .required("PDF file is required")
  .test("fileType", "Only PDF files are allowed", (value) => {
    // Skip validation for existing file paths (string values)
    if (typeof value === "string") {
      return true;
    }
    // Validate only for new file uploads
    return value && value.type === "application/pdf";
  })
  .test("fileSize", "File size must be less than 5 MB", (value) => {
    // Skip validation for existing file paths (string values)
    if (typeof value === "string") {
      return true;
    }
    // Validate only for new file uploads
    return value && value.size <= 5 * 1024 * 1024;
  }),
});
